import React from 'react';
import { Box, CloseIcon, Controller, OptionKey, PlusIcon, RawButton, Text, useFormContext } from '@common-fe/common-fe';
import styled from 'styled-components';

import { IPermissionsSection } from '@/modules/role/role.types';

import SelectRolePermission from './SelectRolePermission';

const Wrapper = styled(Box)`
  &:hover {
    background-color: ${({ theme }) => theme.colors.accentContainer};
  }
`;

interface Props {
  id?: string;
  children?: React.ReactNode;
  isEditMode?: boolean;
  isWithoutRemove?: boolean;
  isStandAloneMode?: boolean;
  onChangeValues?: (values: OptionKey[]) => void;
}

const CopyPermissionsSection: React.FC<Props> = ({
  isStandAloneMode, isEditMode, onChangeValues,isWithoutRemove,children
}) => {
  const {
    control,
  } = useFormContext<IPermissionsSection>();
 
  return (
    <Box
      direction="column"
      round="container1Round"
      background="canvas"
      pad="l"
      margin={{top: 'l'}}
      border={{ size: 'small', color: 'border1' }}
    >
      <Controller
        name="isCopyRole"
        control={control}
        render={({ field }) =>
          field.value ? (
            <Box direction="column"> 
              {children}
              {(!isStandAloneMode && !isWithoutRemove) && (
                <>
                  <Box direction="row" justify="between">
                    <Text size="xxlarge">Copy Permissions</Text>
                    <RawButton onClick={() => field.onChange(false)}>
                      <Box direction="row" align="center">
                        <Text size="medium" weight={400} color="danger">
                          Remove
                        </Text>
                        <Box margin={{ left: 'xxs' }}>
                          <CloseIcon size="16px" color="danger" />
                        </Box>
                      </Box>
                    </RawButton>
                  </Box>
                  <Text margin={{ top: 'l' }}>
                    Create a new role by copying permissions from an existing one. Permissions are set up in the
                    next configuration step.
                  </Text>
                </>
              )}
              <SelectRolePermission
                isStandAloneMode={isStandAloneMode}
                isEditMode={isEditMode}
                onChangeValues={onChangeValues}
              />
            </Box>
          ) : (
            <RawButton onClick={() => field.onChange(true)}>
              <Wrapper
                round="button2Round"
                direction="row"
                pad={{ horizontal: 'xs', vertical: 'spacing6' }}
                align="center"
              >
                <PlusIcon color="iconAccent" size="14px" />
                <Box margin={{ left: 'xxs' }}>
                  <Text color="textAccent" style={{ lineHeight: '20px' }}>
                    Copy Permissions (Optional)
                  </Text>
                </Box>
              </Wrapper>
            </RawButton>
          )}
      />
    </Box>
  );
};

export default CopyPermissionsSection;
